import React from "react"
import Header from "./components/Header"
import { Outlet } from "react-router-dom"

export function Layout():React.ReactElement {
  return (
    <div className="layout-root">
      <Header/>
        <main className="main">
          <Outlet/>
        </main>
    </div>
  );
};

export default Layout;